import React, { Fragment } from 'react';
import DataAvailability from './data-availability';
import Filters from './filters';

const Side = ({ classes }) => {
  return (
    <Fragment>
      <Filters classes={classes} />
      <DataAvailability />
    </Fragment>
  );
};

export default Side;
